import React from "react";
import ErrorBoundary from "src/components/errorBoundary";
import userRoleService from "src/utils/userRoles.service";

function hasAccess(WrappedComponent, type) {
  return function HasAccess(props) {

    const checkAccess = () => {
      switch (type) {

        case 'hub' :
          return userRoleService.canAccessHub();
        
        case 'content-map':
          return userRoleService.canAccessContentMap();
        
        case 'search':
          return userRoleService.canAccessSearch();

        case 'collection':
          return userRoleService.canAccessCollection();
        
        case 'stream':
           return userRoleService.canAccessHub();
        
        case 'conversations':
           return userRoleService.canShare();
        
        case 'reports':
           return userRoleService.canAccessReport();
        
        case 'engage':
           return userRoleService.canAccessEngage();
          
        case 'integrations':
           return userRoleService.canShare();

        case 'user-management':
           return userRoleService.canAccessUserManagement();

        case 'viewer-settings':
           return userRoleService.canAccessPromoteSettings();

        case 'hub-settings':
          return userRoleService.canEditLayout();

        case 'custom-fields':
          return userRoleService.canAccessCustomFields();

        case 'privacy-policy':
          return userRoleService.canAccessPrivacyPolicyControl();

        case 'stream-access-management':
          return userRoleService.canAccessHub() && userRoleService.canCreateStream();
          
        case 'nda-template':
           return userRoleService.canAccessNdaTemplates();

        case 'email-template':
          return userRoleService.canAccessEmailTemplates();

        case 'distribution-lists':
          return userRoleService.canAccessDistributionLists();

        case 'data-sources':
          return userRoleService.canAccessDataSource();



        default:
          return true;

      }

    };

    const access = checkAccess();


    if (!access) {
      return <ErrorBoundary />;
    }

    return <WrappedComponent {...props} />;
  };
}

export default hasAccess;